import { render, staticRenderFns } from "./BulkUpdateUnitLocation.vue?vue&type=template&id=ed8cd550&"
import script from "./BulkUpdateUnitLocation.vue?vue&type=script&lang=js&"
export * from "./BulkUpdateUnitLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports